/**
 * Serializes query params for FastAPI-style backends, which expect repeated keys
 * for array values (`?fields=a&fields=b`) rather than the comma-joined form
 * (`?fields=a,b`) that `URLSearchParams` produces by default.
 */
const fastApiParamsSerializer = (params: Record<string, unknown>): string => {
  const search = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (Array.isArray(value)) {
      value.forEach((v) => search.append(key, String(v)))
    } else if (value !== undefined && value !== null) {
      search.append(key, String(value))
    }
  }
  return search.toString()
}

export default fastApiParamsSerializer
